/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Content } from '../../models/content';
import { UpdateContentListDto } from '../../models/update-content-list-dto';

export interface PhaseControllerReorderContentList$Params {
  phaseId: string;
      body: UpdateContentListDto
}

export function phaseControllerReorderContentList(http: HttpClient, rootUrl: string, params: PhaseControllerReorderContentList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Content>>> {
  const rb = new RequestBuilder(rootUrl, phaseControllerReorderContentList.PATH, 'patch');
  if (params) {
    rb.path('phaseId', params.phaseId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Content>>;
    })
  );
}

phaseControllerReorderContentList.PATH = '/phase/{phaseId}/contentList';
